// extracted by mini-css-extract-plugin
module.exports = {"component":"room-matrix-room-beds_component__9zAwq","heading":"room-matrix-room-beds_heading__QNFPS","content":"room-matrix-room-beds_content__RYAwh"};